module.exports = {"152222100":"巴彦呼舒镇","152222101":"巴仁哲里木镇","152222102":"吐列毛都镇","152222103":"杜尔基镇","152222104":"高力板镇","152222105":"好腰苏木镇","152222200":"代钦塔拉苏木","152222201":"新佳木苏木","152222202":"哈日诺尔苏木","152222203":"额木庭高勒苏木","152222204":"巴彦茫哈苏木","152222205":"巴彦淖尔苏木","152222400":"布敦化牧场","152222401":"吐列毛杜农场","152222402":"孟恩套力盖矿区工作部","152222403":"布敦化矿区工作部"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152222.json
// module id = 480
// module chunks = 0